/* ============================================================
   EX2 MEGA MENU — pointer behaviour
   File: assets/ex2-menu.js  (loaded with defer)

   Adds hover-to-open on desktop ONLY. Click, keyboard, Escape and
   close-on-outside-click are all left to Dawn's existing
   details-disclosure.js <header-menu> element — this file never
   interferes with them, so the menu stays fully operable from the
   keyboard and on touch devices.

   Listeners sit on the whole <header-menu> (which contains the
   panel), not on the <summary>. That means moving the pointer down
   into the panel never leaves the hovered element, so no
   "hover tunnel" hack is needed.
   ============================================================ */
(function () {
  'use strict';

  var OPEN_DELAY = 80; // stops panels flashing while sweeping across the nav
  var CLOSE_DELAY = 150; // forgives a brief slip off the panel edge

  var desktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function wire(root) {
    var menus = (root || document).querySelectorAll('.header__inline-menu header-menu');

    Array.prototype.forEach.call(menus, function (menu) {
      if (menu.dataset.ex2Hover) return;
      menu.dataset.ex2Hover = 'true';

      var details = menu.querySelector('details');
      if (!details) return;
      var openTimer = null;
      var closeTimer = null;

      function clearTimers() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      }

      function open() {
        if (details.open) return;
        // Close any sibling that is already open.
        Array.prototype.forEach.call(menus, function (other) {
          if (other === menu) return;
          var d = other.querySelector('details');
          if (d && d.open) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
      }

      menu.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimers();
        openTimer = setTimeout(open, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        clearTimers();
        closeTimer = setTimeout(function () {
          // Don't fight the keyboard: if focus is inside, leave it open.
          if (details.contains(document.activeElement)) return;
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      });

      // A pointer press should behave like a normal click, not a hover.
      menu.addEventListener('mousedown', clearTimers);
    });
  }

  function boot() {
    wire(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', function (event) {
    wire(event.target);
  });
})();
